import React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import Dropzone from 'react-dropzone';
import classNames from 'classnames';
import { useFeatureFlagsCtx } from 'contexts/FeatureFlags';
import { getIsVideoPodcaster } from 'modules/FeatureFlags';
import { DropdownMenuContainer } from 'components/DropdownMenu/DropdownMenuContainer';
import { useQuickUploadFile } from 'client/contexts/QuickUploadFile';
import { useCreateEpisode } from 'hooks/episodes/useCreateEpisode';
import {
  ACCEPTED_FILE_TYPES_AUDIO_USERS,
  ACCEPTED_FILE_TYPES_VIDEO_USERS,
} from 'screens/EpisodeOptionsScreen/components/EpisodeContent/constants';
import { getNewEpisodeMenuItems } from '../../constants';
import styles from '../../../../shared/Button/styles.sass';

const NewEpisodeNavUnwrapped = (props: RouteComponentProps) => {
  const cx = classNames(styles.button, styles.onDark);
  const { history } = props;
  const { setQuickUploadFile } = useQuickUploadFile();
  const { createNewEpisode } = useCreateEpisode();

  const {
    state: { featureFlags },
  } = useFeatureFlagsCtx();
  const isVideoPodcaster = getIsVideoPodcaster(featureFlags);

  const handleOnDrop = (acceptedFiles: File[]) => {
    setQuickUploadFile(acceptedFiles[0]);
    // create new shell episode and redirect
    // to Episode Options page for new episode
    createNewEpisode(
      {},
      {
        onSuccess: data => {
          history.push(`/dashboard/episode/${data.webEpisodeId}/metadata/edit`);
        },
      }
    );
  };

  return (
    <Dropzone
      onDrop={handleOnDrop}
      accept={
        isVideoPodcaster
          ? ACCEPTED_FILE_TYPES_VIDEO_USERS
          : ACCEPTED_FILE_TYPES_AUDIO_USERS
      }
      noClick
      noKeyboard
      maxFiles={1}
    >
      {({ getRootProps, getInputProps, open }) => {
        return (
          <div {...getRootProps()} style={{ textAlign: 'left' }}>
            <input {...getInputProps()} />
            <DropdownMenuContainer
              buttonStyles={cx}
              renderPressableContent="New Episode"
              shouldShowDistributionItem={false}
              menuItems={getNewEpisodeMenuItems(isVideoPodcaster, open)}
              flyoutBorderRadius={16}
              flyoutMarginTop={4}
              flyoutPaddingTopBottom={0}
              flyoutWidth={278}
              alignFlyout="bottom"
            />
          </div>
        );
      }}
    </Dropzone>
  );
};

const NewEpisodeNav = withRouter(NewEpisodeNavUnwrapped);
export { NewEpisodeNav };
